import nearbyCaution from '../images/caution-icons/nearby-caution.svg';

export const nearbyGeoCautionsIconRenderer = {
    type: 'unique-value', // autocasts as new UniqueValueRenderer()
    field: 'iconName',
    defaultSymbol: {
        type: 'picture-marker',
        url: nearbyCaution,
        width: '24px',
        height: '24px',
    },
    uniqueValueInfos: [
        {
            value: 'geo_caution_default',
            symbol: {
                type: 'picture-marker',
                url: nearbyCaution,
                width: '24px',
                height: '24px',
            },
        },
        {
            value: 'geo_caution_focus',
            symbol: {
                type: 'picture-marker',
                url: nearbyCaution,
                width: '32px',
                height: '32px',
            },
        },
    ],
    authoringInfo: undefined,
};
